import { getRequest, postRequest } from '../api-handler';
import { SpecificationDetailDto, SpecificationDto } from './specification';

export const SpecificationApi = {
  getById: (id: number) =>
    getRequest<SpecificationDetailDto>(`/specifications/${id}`),
  getByGrade: (gradeId: number) =>
    getRequest<SpecificationDto[]>(`/specifications/grades/${gradeId}`),
  createVismaProduct: (id: number) =>
    postRequest(`/specifications/${id}/createvismaproduct`, id)
};
